module.exports = { "default": require("core-js/library/fn/object/create"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-runtime/core-js/object/create.js
// module id = 231
// module chunks = 0 1


// WEBPACK FOOTER //
// webpack:///node_modules/babel-runtime/core-js/object/create.js